<template>
  <v-layout row wrap class="pt-0 pl-0 pr-0 pb-3 encode">
    <v-layout class="blue-background white--text">
      <v-flex xs9>
        <div class="encode title font-weight-black white--text all-upper-case pl-3 pt-3 pb-1">Videos</div>
        <div
          class="encode subheading font-weight-black font-italic pl-3 pb-3"
        >Watch and learn... {{ false ? this.$vuetify.breakpoint.name : '' }}</div>
      </v-flex>
      <v-flex xs3 class="pb-2 pr-0">
        <v-layout justify-end>
          <v-avatar size="100px" tile>
            <img
              align-right
              style="background: #004a80"
              :src="require('@/assets/youtube2.png')"
              alt="image for YouTube section"
            >
          </v-avatar>
        </v-layout>
      </v-flex>
    </v-layout>

    <div v-if="false">
      <v-layout row wrap align-center justify-space-around class="pt-3">
        <v-flex v-for="(video, index) in this.videosWithUris" :key="video.videoId" xs12 sm6 md6 lg4>
          <v-layout justify-center pb-2>
            <iframe
              width="890"
              :id="'ytplayer'+index"
              theheight="712"
              :src="video.uri"
              frameborder="0"
              allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
              allowfullscreen
            ></iframe>
          </v-layout>
        </v-flex>
      </v-layout>
    </div>

    <div v-if="true">
      <v-layout row wrap align-center justify-space-around class="pt-3">
        <v-flex v-for="video in this.videos2" :key="video.id" xs12 sm6 md6 lg4>
          <v-layout justify-center pb-2>
            <v-card elevation-2 light>
              <!-- https://github.com/vuetifyjs/vuetify/issues/3558 -->
              <v-card-title class="justify-center">
                <h4 class="encode blue-text no-underline justify-center text-xs-center pb-1">
                  <a
                    :href="'http://www.youtube.com/watch?v=' + video.snippet.resourceId.videoId"
                  >{{ video.snippet.title }}</a>
                </h4>
								<div>
                <a :href="'http://www.youtube.com/watch?v=' + video.snippet.resourceId.videoId">
                  <img
                    :src="getSnippet(video)"
                    :alt="video.snippet.title"
                    :title="video.snippet.title"
                    class="thumbnail"
                  >
                </a>
								</div>
              </v-card-title>
            </v-card>
          </v-layout>
        </v-flex>
      </v-layout>
    </div>
  </v-layout>
</template>

<script>
import { importedVideoData } from "../model/imported-youtube-api-data.js";
export default {
  name: "VideoPreview",
  props: {
    videos: Array
  },
  computed: {
    videos2: function() {
      return importedVideoData.items;
    },
    videosWithUris: function() {
      return this.videos.map(v => {
        return {
          name: v.name,
          videoId: v.videoid,
          uri: "https://www.youtube.com/embed/" + v.videoId
        };
      });
    }
  },
  methods: {
    getSnippet: function(video) {
      switch (this.$vuetify.breakpoint.name) {
        case "xs":
          return video.snippet.thumbnails.medium.url;
        case "sm":
          return video.snippet.thumbnails.medium.url;
        case "md":
          return video.snippet.thumbnails.medium.url;
        case "lg":
          return video.snippet.thumbnails.medium.url;
			}
			// Default
			return video.snippet.thumbnails.medium.url;
    }
  }
};
</script>
